import React, {useRef, useState} from "react";
import axios from "axios";
import {
  getErrorMessageByKey,
  Input,
  jsonFormatText,
  Modal,
  Select,
  Textarea,
  useNotification,
} from "@vokymlak/kabinet-ui";
import ModalRealizationBranchSelect from "./ModalRealizationBranchSelect";
import {ROOT_URL} from "../../../../config/url";

function ModalRealizationBranchAdd(props) {
  const [selectItem, setSelectItem] = useState(null)
  const [isModalSelectItem, setIsModalSelectItem] = useState(false)
  const [isRequest, setIsRequest] = useState(false)

  const {notification} = useNotification();

  const changeAdd = () => {
    if (isRequest) {
      return;
    }

    if (!selectItem) {
      notification("Заполните все обязательные поля", "red");
      return;
    }

    const jsonData = JSON.stringify({
      branch: !!selectItem ? {
        uuid: selectItem.uuid,
      } : null,
    });

    setIsRequest(true);

    axios
      .post("/api/realization-branch/add", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Филиал добавлен", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      })
      .finally(() => {
        setIsRequest(false);
      });
  };

  return (
    <>
      <Modal handleClose={() => props.handleClose()}>
        <div className="Form">
          <div className="Form__title">
            Новый филиал реализации
          </div>

          {!selectItem && (
            <div className="Form__field Form__field_last"
                 style={{
                   cursor: "pointer"
                 }}
                 onClick={() => setIsModalSelectItem(true)}>
              <div className="Field__label">
                Филиал
              </div>
              <div className="Field__text">
                -
              </div>
            </div>
          )}

          {!!selectItem && (
            <div className="Form__field Form__field_last"
                 style={{
                   cursor: "pointer"
                 }}
                 onClick={() => setIsModalSelectItem(true)}>
              <div className="Field__label">
                Филиал
              </div>
              <div className="Field__text">
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: 700,
                    width: "100%",
                  }}
                >
                  {!!selectItem.short_name && selectItem.short_name}
                  <div style={{
                    fontSize: 12,
                    fontWeight: 400,
                  }}>
                    {!!selectItem.name && selectItem.name}
                  </div>
                  <div style={{
                    fontSize: 12,
                    fontWeight: 400,
                  }}>
                    <span style={{marginRight: 8}}>ОГРН:&nbsp;{(!!selectItem.ogrn && selectItem.ogrn) || "-"}</span>
                    <span style={{marginRight: 8}}>ИНН:&nbsp;{(!!selectItem.inn && selectItem.inn) || "-"}</span>
                    <span style={{marginRight: 8}}>КПП:&nbsp;{(!!selectItem.kpp && selectItem.kpp) || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="Form__actions Form__actions_center">
            <button className="Action__button Action__button_all Action__button_blue"
                    onClick={() => changeAdd()}>
              Добавить
            </button>
          </div>
        </div>
      </Modal>

      {isModalSelectItem && (
        <ModalRealizationBranchSelect
          item={selectItem}
          successfulRequest={item =>
            setSelectItem(item)
          }
          handleClose={() => setIsModalSelectItem(false)}
        />
      )}
    </>
  );
}

export default ModalRealizationBranchAdd;
